module.exports = __webpack_public_path__ + "img/dark_ic_creation_step3.7fbd8f28.png";